import React, { useEffect } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import EligibilityEnginePageView from '../views/EligibilityEnginePage/Index';
import {
  useEligibilityProducts,
  useEligibilityActions,
} from '../hooks/useEligibilityEngine';

const EligibilityEnginePage = () => {
  const { productsLoading, productsError, selectedProduct } = useEligibilityProducts();
  const { fetchProducts, setRules, fetchRules } = useEligibilityActions();

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  // Fetch rules whenever the selected product changes
  useEffect(() => {
    if (selectedProduct) {
      fetchRules(selectedProduct);
    }
  }, [selectedProduct, setRules]);

  if (productsLoading) {
    return <div>Loading products...</div>;
  }

  if (productsError) {
    return <div>Error loading products. Please try again.</div>;
  }

  return <EligibilityEnginePageView />;
};

export default compose(withRouter)(EligibilityEnginePage);
